import React, { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';
import { siteContentService } from '../services/api';

function Privacy() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        const response = await siteContentService.get('INFORMATION_PRIVACY');
        if (response.data && response.data.value) {
          setContent(response.data.value);
        }
      } catch (error) {
        console.error('Error fetching privacy:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPrivacy();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">حریم خصوصی</h1>
          <p className="text-xl text-blue-100">سیاست حریم خصوصی نشریه مجری</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <section className="bg-white rounded-xl shadow-md p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
            <Shield className="text-blue-700" size={24} />
            حریم خصوصی
          </h2>
          <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">{content}</p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
